module.exports = __webpack_public_path__ + "static/media/quality-content_icon.2db8a6a2.jpg";